import { lazy } from 'react';

// After a deploy, Firebase Hosting drops the old hashed chunk files and the
// SPA rewrite serves index.html in their place, so stale tabs hit
// ChunkLoadError when navigating. Recovery: reload once to pick up the new
// release; a sessionStorage flag prevents reload loops.
const RELOAD_FLAG = 'chunk-error-reloaded';

const hasReloaded = () => {
    try {
        return sessionStorage.getItem(RELOAD_FLAG) === '1';
    } catch {
        return true;
    }
};

const markReloaded = () => {
    try {
        sessionStorage.setItem(RELOAD_FLAG, '1');
    } catch {
        // sessionStorage unavailable — fall through to the error boundary
    }
};

export const clearReloadFlag = () => {
    try {
        sessionStorage.removeItem(RELOAD_FLAG);
    } catch {
        // ignore
    }
};

export const isChunkLoadError = (error) => {
    if (!error) return false;
    if (error.name === 'ChunkLoadError') return true;
    return /loading (css )?chunk .* failed/i.test(error.message || '');
};

// Reloads once for a chunk error; returns true if the reload was triggered.
export const reloadOnceForChunkError = (error) => {
    if (!isChunkLoadError(error) || hasReloaded()) return false;
    markReloaded();
    window.location.reload();
    return true;
};

export const lazyWithReload = (importFn) =>
    lazy(() =>
        importFn().catch((error) => {
            if (reloadOnceForChunkError(error)) {
                // Page is reloading — keep Suspense showing its fallback
                return new Promise(() => {});
            }
            throw error;
        })
    );
